import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Reveal, Overline, BookButton } from "@/components/bits";

const PARTNERS = [
  { name: "Gjensidige", logo: "/assets/partner-gjensidige.png" },
  { name: "Storebrand", logo: "/assets/partner-storebrand.png" },
  { name: "Ergo", logo: "/assets/partner-ergo.png" },
  { name: "Avonova", logo: "/assets/partner-avonova.png" },
  { name: "Nordic Netcare", logo: "/assets/partner-nordicnetcare.png" },
];

export default function Helseforsikring() {
  return (
    <>
      <Seo
        title="Helseforsikring | Actus Osteopati – Osteopat Oslo"
        description="Informasjon om helseforsikring og osteopatibehandling hos Actus Osteopati i Oslo sentrum."
      />
      <PageHeader
        overline="Actus Osteopati"
        title="Helseforsikring"
        testId="helseforsikring-heading"
      />

      <section data-testid="helseforsikring-content" className="bg-paper py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal className="text-center max-w-2xl mx-auto">
            <Overline>Dekning</Overline>
            <h2 className="font-display font-light text-3xl md:text-4xl leading-tight">
              Forsikring og osteopati
            </h2>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-ink-soft">
              Har du behandlings- eller helseforsikring gjennom arbeidsgiver
              eller privat? Mange helseforsikringer dekker behandling hos
              osteopat.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Vi anbefaler at du tar kontakt med forsikringsselskapet ditt før
              første behandling for å undersøke om din forsikring dekker
              osteopatisk behandling, og om det kreves forhåndsgodkjenning.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Dersom behandlingen er godkjent, ber vi deg ha nødvendig
              informasjon tilgjengelig ved første konsultasjon, for eksempel
              skadenummer eller saksnummer og eventuell betalingsgaranti.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Er du usikker på om du kan benytte helseforsikringen din hos oss?{" "}
              <Link
                to="/kontakt"
                className="underline underline-offset-4 decoration-ink/30 hover:decoration-ink transition-colors duration-300"
              >
                Ta gjerne kontakt med oss
              </Link>
              , så hjelper vi deg med å finne ut av det.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <div data-testid="insurance-partners" className="mt-16 md:mt-20 max-w-4xl mx-auto">
              <p className="text-xs tracking-[0.3em] uppercase text-ink-soft/60 mb-8 text-center">
                Vi er tilknyttet følgende forsikringsselskaper
              </p>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
                {PARTNERS.map((p) => (
                  <div
                    key={p.name}
                    data-testid={`partner-${p.name.toLowerCase().replace(/\s/g, "-")}`}
                    className="bg-white border border-ink/10 flex items-center justify-center px-8 py-10"
                  >
                    {p.logo ? (
                      <img src={p.logo} alt={`${p.name} logo`} loading="lazy" className="max-h-9 w-auto object-contain" />
                    ) : (
                      <span className="font-display font-light text-xl md:text-2xl text-ink">{p.name}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.2} className="mt-14 text-center">
            <BookButton testId="helseforsikring-book-button" dark label="Book time" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
